<section class="mx-auto w-full max-w-5xl space-y-6 p-4 sm:p-6">
  <!-- HEADER -->
  <header
    class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
  >
    <div class="flex items-center gap-3">
      <div
        class="flex size-12 shrink-0 items-center justify-center rounded-2xl bg-blue-50 text-primary-900"
      >
        <svg
          class="size-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.8"
            d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m9-13a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm4 2 2 2 4-4"
          />
        </svg>
      </div>

      <div>
        <h1 class="text-xl font-bold tracking-tight text-slate-900">
          Tus sesiones
        </h1>

        <p class="mt-1 text-sm text-slate-500">
          Administrá los dispositivos donde iniciaste sesión.
        </p>
      </div>
    </div>

    <button
      type="button"
      (click)="modal.openModal()"
      class="inline-flex items-center justify-center gap-2 rounded-xl bg-primary-500 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-primary-700 focus:outline-none focus:ring-4 focus:ring-blue-100"
    >
      <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 3 5 6v5c0 4.5 3 8 7 10 4-2 7-5.5 7-10V6l-7-3Z"
        />
      </svg>

      Administrar sesiones
    </button>
  </header>

  <!-- RESUMEN -->
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
    <div class="rounded-2xl border border-slate-200 bg-white p-5">
      <p class="text-sm font-medium text-slate-500">Sesiones activas</p>

      <p class="mt-2 text-3xl font-bold text-slate-900">
        {{ activeSessions() }}
      </p>
    </div>

    <div class="rounded-2xl border border-slate-200 bg-white p-5">
      <p class="text-sm font-medium text-slate-500">Sesiones cerradas</p>

      <p class="mt-2 text-3xl font-bold text-slate-900">
        {{ revokedSessions() }}
      </p>
    </div>

    <div class="rounded-2xl border border-slate-200 bg-white p-5">
      <p class="text-sm font-medium text-slate-500">Doble factor</p>

      <div class="mt-3 flex items-center gap-2">
        <span
          class="size-2 rounded-full"
          [class.bg-emerald-500]="dobleFactorActivado()"
          [class.bg-slate-400]="!dobleFactorActivado()"
        ></span>

        <span class="text-sm font-semibold text-slate-700">
          {{ dobleFactorActivado() ? 'Activado' : 'Desactivado' }}
        </span>
      </div>
    </div>
  </div>

  <!-- SESIONES ACTIVAS -->
  <div class="overflow-hidden rounded-2xl border border-slate-200 bg-white">
    <div
      class="flex items-center justify-between border-b border-slate-100 px-5 py-4"
    >
      <div>
        <h2 class="font-semibold text-slate-900">Dispositivos</h2>

        <p class="mt-1 text-sm text-slate-500">
          Revisá dónde está abierta tu cuenta.
        </p>
      </div>

      <span
        class="rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700"
      >
        {{ activeSessions() }} activas
      </span>
    </div>

    @if (activeSessions()) {
      <div class="divide-y divide-slate-100">
        @for (session of sessions(); track session.id) {
          <article
            class="flex flex-col gap-4 p-5 transition hover:bg-slate-50/70 sm:flex-row sm:items-start"
          >
            <!-- ICONO -->
            <div
              class="flex size-12 shrink-0 items-center justify-center rounded-2xl bg-blue-50 text-xl text-primary-900"
            >
              {{ deviceIcon(session.deviceType) }}
            </div>

            <!-- INFORMACIÓN -->
            <div class="min-w-0 flex-1">
              <div class="flex flex-wrap items-center gap-2">
                <h3 class="wrap-break-word font-semibold text-slate-900">
                  {{ session.deviceName }}
                </h3>

                @if (session.refreshTokenHash === currentSessionId()) {
                  <span
                    class="rounded-full bg-blue-50 px-2.5 py-1 text-xs font-medium text-primary-900"
                  >
                    Este dispositivo
                  </span>
                }
              </div>

              <p class="mt-1 text-sm text-slate-500">
                {{ session.browser }}
                <span class="mx-1">·</span>
                {{ session.operatingSystem }}
              </p>

              <div
                class="mt-3 flex flex-col gap-2 text-sm text-slate-500 sm:flex-row sm:flex-wrap sm:gap-x-5"
              >
                @if (session.where) {
                  <span class="flex items-center gap-2">
                    <svg
                      class="size-4 shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.8"
                        d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"
                      />
                      <circle cx="12" cy="10" r="2.5" stroke-width="1.8" />
                    </svg>

                    {{ session.where }}
                  </span>
                }

                <span class="flex items-center gap-2">
                  <svg
                    class="size-4 shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <circle cx="12" cy="12" r="9" stroke-width="1.8" />
                    <path
                      stroke-linecap="round"
                      stroke-width="1.8"
                      d="M12 7v5l3 2"
                    />
                  </svg>

                  Última actividad:
                  {{ session.lastActivityAt | date: 'dd/MM/yyyy, HH:mm' }}
                </span>
              </div>
            </div>

            <!-- ESTADO -->
            <div class="flex shrink-0 items-center gap-3 sm:pt-1">
              <span
                class="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700"
              >
                Activa
              </span>
            </div>
          </article>
        }
      </div>
    } @else {
      <div class="px-6 py-12 text-center">
        <div
          class="mx-auto flex size-12 items-center justify-center rounded-full bg-slate-100 text-slate-500"
        >
          <svg
            class="size-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="9" stroke-width="1.8" />
            <path stroke-linecap="round" stroke-width="1.8" d="M8 12h8" />
          </svg>
        </div>

        <p class="mt-3 font-semibold text-slate-900">No hay sesiones activas</p>

        <p class="mt-1 text-sm text-slate-500">
          No encontramos dispositivos con sesiones abiertas.
        </p>
      </div>
    }
  </div>

  <!-- MODAL -->
  <c-session-modal
    #modal
    [sessions]="sessions()"
    [dobleFactorActivado]="dobleFactorActivado()"
    [currentSessionId]="currentSessionId()"
    (revokeSession)="revokeSession($event)"
  />
</section>
